import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { NumberPropsTypes, TOnWheel } from "../NumberPropsTypes";
import "../SCSS/styles.css";

function Number({
  isPreview,
  questionId,
  surveyAnswers,
  handleChangeInputNumber,
  surveyAnswersInfo,
  reducerState,
}: NumberPropsTypes) {
  return (
    <div className="supplier-view-number-cover">
      <div className="supplier-view-number-lower-limit-cover">
        <input
          id={questionId}
          disabled={
            isPreview ||
            surveyAnswers?.[questionId]?.notApplicableInfo?.isNotApplicable
          }
          type="number"
          className="limits"
          placeholder="Please enter number"
          onChange={(e) =>
            surveyAnswersInfo?.surveyStatus !==
              EnumSurveyAnswerStatus?.COMPLETED &&
            !surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable &&
            handleChangeInputNumber!(questionId, e)
          }
          value={surveyAnswers?.[questionId]?.val ?? ""}
          onWheel={(e: TOnWheel) => e.target.blur()}
        />
      </div>
      {reducerState?.validNumberErrorMessage?.[questionId]?.length! > 0 && (
        <p className="valid-number-msg">
          {reducerState?.validNumberErrorMessage?.[questionId]}
        </p>
      )}
      {surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[questionId]
        ?.emissionFactor?.enabled &&
        !isPreview && (
          <div className="supplier-view-number-emission-factor">{`emission factor is ${surveyAnswersInfo?.surveyInfo?.questionsInfo?.questionObj?.[questionId]?.emissionFactor?.value}`}</div>
        )}
    </div>
  );
}

export default Number;
